/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * News images dot component
 *
 * @author Alexander Golshtein
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.0
 */

import { CarouselDotStyled } from '@pages/PageNews/styled/NewsImagesStyled';

interface INewsImagesDotsProps {
    active?: boolean;
    onClick?: () => void;
}

const NewsImagesDots = ({ active = false, onClick }: INewsImagesDotsProps) => (
    <CarouselDotStyled active={active} onClick={onClick} />
);

export default NewsImagesDots
